import { Box } from '@mui/material';
import {
  AccountCircle,
  EmojiEvents,
  Groups,
  Replay,
} from '@mui/icons-material';
import { DqStatCard, SectionTitle, STAT_CARD_GRID_4_SX } from './dqShared';

const DqTodaySection = ({ today }) => {
  if (!today) return null;

  return (
    <>
      <SectionTitle>Today&apos;s Stats</SectionTitle>
      <Box sx={STAT_CARD_GRID_4_SX}>
        <DqStatCard
          title="Answered today"
          value={today.answeredToday}
          subtitle={
            today.eligibleLoggedIn
              ? `of ${Number(today.eligibleLoggedIn).toLocaleString()} logged-in users.`
              : undefined
          }
          icon={<AccountCircle sx={{ color: 'primary.main' }} />}
          valueColor="primary.main"
        />
        <DqStatCard
          title="First time today"
          value={today.firstTimeToday}
          subtitle="Have answered today for the first time."
          icon={<Groups sx={{ color: 'success.main' }} />}
          valueColor="success.main"
        />
        <DqStatCard
          title="Returning today"
          value={today.returningToday}
          subtitle="Have answered before at least once and answered today."
          icon={<Replay sx={{ color: 'primary.main' }} />}
          valueColor="primary.main"
        />
        <DqStatCard
          title="Streak extended today"
          value={today.streakExtendedToday}
          subtitle="Also answered yesterday."
          icon={<EmojiEvents sx={{ color: '#ff9800' }} />}
          valueColor="#ff9800"
        />
      </Box>
    </>
  );
};

export default DqTodaySection;
